(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_urgency-box"] && !Shopify.designMode) return;
  try {
    function initUrgencyCounter(el, min, max, hours, key) {
    if (!el) return;
    let value = null;
    try {
      const saved = JSON.parse(localStorage.getItem(key) || 'null');
      if (saved && Date.now() - saved.t < hours * 3600 * 1000 && saved.v >= min && saved.v <= max) {
        value = saved.v;
      }
    } catch (e) {
      /* storage unavailable */
    }
    if (value === null) {
      value = Math.floor(Math.random() * (max - min + 1)) + min;
      try {
        localStorage.setItem(key, JSON.stringify({ v: value, t: Date.now() }));
      } catch (e) {
        /* storage unavailable */
      }
    }
    el.textContent = value;
  }

  document.querySelectorAll('[data-urgency-box]').forEach((box) => {
    initUrgencyCounter(
      box.querySelector('[data-people-count]'),
      parseInt(box.dataset.peopleMin, 10) || 20,
      parseInt(box.dataset.peopleMax, 10) || 40,
      parseFloat(box.dataset.peopleIntervalHours) || 6,
      box.dataset.peopleKey
    );
    initUrgencyCounter(
      box.querySelector('[data-stock-count]'),
      parseInt(box.dataset.stockMin, 10) || 6,
      parseInt(box.dataset.stockMax, 10) || 12,
      parseFloat(box.dataset.stockIntervalHours) || 6,
      box.dataset.stockKey
    );
  });
  } catch(e) { console.error(e); }
})();

})();
